import React, { useState, useEffect, useRef } from "react";
import { optionsBranch } from "../data/branch-data";
import { internType } from "../data/interntype-data";
import { thaiMonth } from "../data/month-thai";
import {
  convertDateThai,
  converToThaiNumber,
  matchOptions,
  changePrefixName,
} from "../utils/function";
import { useReactToPrint } from "react-to-print";

import { useSelector } from "react-redux";
import { getFormAnswer } from "../api/crud";
import { useForm } from "react-hook-form";
import { Box, Button, Checkbox, FormControlLabel } from "@mui/material";
import Barcode from "react-barcode";

const FormTransfer = ({ docData }) => {
  const profile = useSelector((state) => state.profileReducer.profile);
  const [allStd, setAllStd] = useState([]);
  const [activeStd, setActiveStd] = useState([]);
  const [selectedStd, setSelectedStd] = useState([]);
  const [page, setPage] = useState(1);

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const { register, watch, setValue } = useForm();
  const [defValue, setDefValue] = useState(null);

  const onHandleCheckAll = () => {
    if (allStd.length === selectedStd.length) {
      setSelectedStd([]);
    } else {
      setSelectedStd([...allStd]);
    }
  };

  const onHandleCheck = (item) => {
    const prevData = [...selectedStd];

    const isExist = prevData.indexOf(item) !== -1;

    if (!isExist) {
      setSelectedStd([...prevData, item]);
    } else {
      const newData = prevData.filter((el) => el.id !== item.id);

      setSelectedStd(newData);
    }
  };
  const getData = () => {
    getFormAnswer().then((res) => {
      const findList = res.find((el) => el.idm_doc_id === docData.idm_doc_id);

      const jsonData = {
        coordinator: JSON.parse(findList.coordinator),
      };

      if (findList) {
        setDefValue(jsonData);
        setValue("coordinator.comment", jsonData.coordinator.comment);
      } else {
        setDefValue(null);
      }
    });
  };

  const onGenerateForm = () => {
    setActiveStd(selectedStd);
    setPage(2);
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (docData) {
      const std = docData?.internStd.filter(
        (el) => el.internStudent.status_id_2 == "31"
      );
      setAllStd(std);
    }
  }, [docData]);

  const displaySelection = (
    <Box minWidth={600} p={3}>
      <FormControlLabel
        label="ทั้งหมด"
        control={
          <Checkbox
            checked={!selectedStd.length === activeStd.length}
            indeterminate={
              selectedStd.length && selectedStd.length !== activeStd.length
            }
           
            onChange={onHandleCheckAll}
          />
        }
      />
      <Box sx={{ display: "flex", flexDirection: "column", ml: 3 }}>
        {docData?.internStd.filter(
           (st) => st.internStudent.status_id_2 == "31"
        ).map((el) => { 
         
          return (
            <FormControlLabel
              label={`${el?.internStudent.id} ${el?.internStudent.name} `}
              control={
                <Checkbox
                  
                  checked={!!selectedStd.find((std) => el.st_id == std.st_id)}
                  onChange={() => onHandleCheck(el)}

                />
              }
            />
          );
        })}
      </Box>

      <Button onClick={onGenerateForm}>สร้างเอกสาร</Button>
    </Box>
  );

  const displayForm = (
    <div>
      <Button onClick={() => setPage(1)}>Back</Button>
      <section
        className="sheet   print-container react-print-container"
        style={{ color: "black" }}
        id="section-to-print"
        ref={componentRef}
      >
        <div className="row">
          <div className="col-12 text-center" style={{ height: "22mm" }}>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/buu-logo-2.png`}
              alt="buu logo"
              width="100px"
            />
          </div>
          <div className="col-7 mb-3">
            <div>
              ที่ อว ๘๑๑๖/
              <input
                style={{ width: "50px" }}
                type="text"
                className="input-form border-0 text-start"
                name="idm_docnum"
              />
            </div>
          </div>
          <div className="col-5 mb-3 d-flex justify-content-end">
            <div>
              <div>คณะวิศวกรรมศาสตร์ มหาวิทยาลัยบูรพา</div>
              <div>ตำบลแสนสุข อำเภอเมืองฯ</div>
              <div>จังหวัดชลบุรี ๒๐๑๓๑</div>
            </div>
          </div>
          <div className="col-6 mb-4"></div>
          <div className="col-6 ps-0 mb-4">
            <div>
              <input
                style={{ width: "150px" }}
                type="text"
                className="input-form border-0 text-start"
                name="idm_docdate"
                value={`  ${
                  thaiMonth[new Date().getMonth()]
                }  ${converToThaiNumber(new Date().getFullYear() + 543)}`}
              />
            </div>
          </div>
          <div className="col-12 mb-4">
            <div>
              เรื่อง <span style={{ marginRight: "5mm" }} />
              ขอส่งตัวเข้ารับนิสิต
              {converToThaiNumber(
                matchOptions(internType, docData?.type_intern)
              )}{" "}
              ประจำปี {converToThaiNumber(new Date().getFullYear() + 543)}
            </div>
          </div>
          <div className="col-12">
            <div>
              <span className="me-2">เรียน</span>
              <span style={{ marginRight: "3mm" }} />
              <input
                style={{ width: "90%" }}
                type="text"
                name="idm_header"
                className="input-form border-0"
                {...register("coordinator.comment")}

                // {`${activeStd
                //   .map((el) => {
                //     return `${changePrefixName(
                //       el?.internshipRequest?.co_name,
                //       "คุณ"
                //     )} ${el?.internshipRequest?.comment}`;
                //   })
                //   .join(" / ")} `}
                // value={`${changePrefixName(
                //   companyDetail?.internStudent[0]?.internDetail?.co_name,
                //   "คุณ"
                // )} `}
              />
            </div>
          </div>

          <div className="col-12 mb-4" style={{ textIndent: "48px" }}>
            <div>{converToThaiNumber(docData?.companyDetail?.name)}</div>
          </div>

          {/* <div className="col-12 mb-4">
        <div>
          อ้างถึง <span style={{ marginRight: "5mm" }} />
          แบบฟอร์มตอบรับนิสิตเข้ารับการฝึกงาน
        </div>
      </div> */}

          <div className="col-12 mb-2" style={{ textIndent: "75px" }}>
            ตามแบบตอบรับนิสิตเข้าปฏิบัติงาน จาก{" "}
            {converToThaiNumber(docData?.companyDetail?.name)}{" "}
            ได้ให้ความอนุเคราะห์รับนิสิต คณะวิศวกรรมศาสตร์ เข้ารับ{""}
            {converToThaiNumber(
              matchOptions(internType, docData?.type_intern)
            )}{" "}
            ระหว่าง
            <span className="text-nowrap">วันที่</span>
            {convertDateThai(
              activeStd[0]?.internshipRequest?.start_date,
              true
            )}{" "}
            ถึง วันที่
            {convertDateThai(
              activeStd[0]?.internshipRequest?.end_date,
              true
            )}{" "}
            ตามความทราบแล้วนั้น
          </div>
          <div className="col-12 mb-2" style={{ textIndent: "75px" }}>
            เพื่อให้การปฏิบัติงานสำหรับนิสิตเป็นไปด้วยความเรียบร้อย
            คณะวิศวกรรมศาสตร์ จึงขอส่งตัวนิสิตเข้ารับ
            {converToThaiNumber(
              matchOptions(internType, docData?.type_intern)
            )}{" "}
            ในหน่วยงานของท่าน ตามวันเวลาดังกล่าวข้างต้น จำนวน{" "}
            {converToThaiNumber(activeStd?.length)} คน ดังนี้
          </div>

          <div className="col-12">
            {activeStd &&
              activeStd.length &&
              activeStd.map((std, index) => {
                const levelRaw =
                  +std?.internStudent?.school_yrs?.slice(-2) +
                  1 -
                  +std?.internStudent?.id.slice(0, 2);
                const level = levelRaw <= 4 ? levelRaw : 4;

                return (
                  <div className="row" style={{ margin: "0 auto" }} key={index}>
                    <div className="col-6" style={{ textIndent: "50px" }}>
                      {converToThaiNumber(index + 1)}){" "}
                      {std?.internStudent?.name}
                    </div>
                    <div className="col-6">
                      นิสิตปีที่ {converToThaiNumber(level)} สาขาวิชา{" "}
                      {matchOptions(optionsBranch, std?.internStudent?.b_id)}
                    </div>
                  </div>
                );
              })}
          </div>
          <div className="col-12 mt-4" style={{ textIndent: "75px" }}>
            จึงเรียนมาเพื่อโปรดพิจารณา และขอขอบคุณเป็นอย่างสูงมา ณ ที่นี้
          </div>
          <div className="col-12 mt-4 d-flex justify-content-end">
            <div className="text-center" style={{ paddingRight: "39mm" }}>
              <div>ขอแสดงความนับถือ</div>
              <div style={{ height: "15mm" }} />
              <div>
                <div>
                  <input
                    style={{ width: "300px" }}
                    name="president"
                    type="text"
                    className="input-form border-0 text-center"
                    defaultValue={"(ผู้ช่วยศาสตราจารย์ ดร.ณยศ คุรุกิจโกศล)"}
                  />
                </div>
                <div>
                  <input
                    style={{ width: "300px" }}
                    name="president_pos1"
                    type="text"
                    className="input-form border-0 text-center"
                    defaultValue={"คณบดีคณะวิศวกรรมศาสตร์"}
                  />
                </div>
                <div>
                  <input
                    style={{ width: "300px" }}
                    name="president_pos2"
                    type="text"
                    className="input-form border-0 text-center"
                  />
                </div>
              </div>
            </div>
          </div>

          {activeStd?.length <= 2 && <div className="col-12 text-center" style={{ height: "25mm" }}/>} 
          {activeStd?.length == 3 && <div className="col-12 text-center" style={{ height: "20mm" }}/>} 
          {activeStd?.length == 4 && <div className="col-12 text-center" style={{ height: "10mm" }}/>} 
          {activeStd?.length == 5 && <div className="col-12 text-center" style={{ height: "5mm" }}/>} 
          <div className="col-12 text-center" style={{ height: "5mm" }}/>
         
          <div className="col-6" >
            <div>สำนักงานคณบดี </div>
            <div>โทร. ๐ ๓๘๑๐ ๒๒๒๒ ต่อ ๓๓๑๕, ๓๓๒๔ </div>
            <div>ไปรษณีย์อิเล็กทรอนิกส์ co-op@eng.buu.ac.th</div>
          </div>

          <div className="col-6 d-flex align-items-end justify-content-end">
                <Barcode
                  value={docData?.idm_doc_id}
                  width={1.5}
                  height={20}
                  fontSize={10}
                />
              </div>
        </div>
        
      </section>

      <div className="text-center pb-4">
        <div className="btn btn-primary btn-sm " onClick={handlePrint}>
          พิมพ์เอกสาร
        </div>
      </div>
    </div>
  );

  return <div>{page === 1 ? displaySelection : displayForm}</div>;
};

export default FormTransfer;
